<template>
  <div class="news-detail-page">
    <div class="page-header">
      <div class="container">
        <h1>新闻动态</h1>
        <p>了解公司最新动态和行业资讯</p>
      </div>
    </div>
    
    <div class="container detail-container">
      <div class="article-wrapper">
        <div class="article-header">
          <h1 class="article-title">{{ article.title }}</h1>
          <div class="article-meta">
            <span class="meta-item">
              <IconFont name="time" size="16px" color="#999" />
              <span>发表时间：{{ article.createTime }}</span>
            </span>
          </div>
        </div>
        
        <div class="article-content" v-html="article.content"></div>
        
        <div class="article-footer">
          <el-button type="primary" @click="goBack">
            <IconFont name="arrow-left" size="14px" color="#fff" />
            返回列表
          </el-button>
        </div>
        
        <div class="article-nav" v-if="relatedArticles.length > 0">
          <div class="nav-prev" v-if="prevArticle">
            <span class="nav-label">上一篇：</span>
            <a href="#" @click.prevent="goToArticle(prevArticle.id)" class="nav-link">{{ prevArticle.title }}</a>
          </div>
          <div class="nav-next" v-if="nextArticle">
            <span class="nav-label">下一篇：</span>
            <a href="#" @click.prevent="goToArticle(nextArticle.id)" class="nav-link">{{ nextArticle.title }}</a>
          </div>
        </div>
        
        <div class="article-share">
          <span class="share-label">分享到：</span>
          <div class="share-icons">
            <button class="share-btn weixin" title="分享到微信" @click="shareToWeixin">
              <IconFont name="weixin" size="38px" color="#7bb32e" />
            </button>
            <button class="share-btn qq" title="分享到QQ" @click="shareToQQ">
              <IconFont name="qq" size="38px" color="#1296db" />
            </button>
            <button class="share-btn qzone" title="分享到QQ空间" @click="shareToQzone">
              <IconFont name="qq-zone" size="38px" color="#f5a623" />
            </button>
            <button class="share-btn douban" title="分享到豆瓣" @click="shareToDouban">
              <IconFont name="douban" size="38px" color="#007722" />
            </button>
            <button class="share-btn weibo" title="分享到微博" @click="shareToWeibo">
              <IconFont name="weibo" size="38px" color="#e6162d" />
            </button>
            <button class="share-btn tieba" title="分享到贴吧" @click="shareToTieba">
              <IconFont name="tieba" size="38px" color="#1e74e8" />
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getNewsDetail, getNewsList } from '@/api/news'

export default {
  name: 'NewsDetail',
  data() {
    return {
      articleId: null,
      article: null,
      relatedArticles: [],
    }
  },
  computed: {
    prevArticle() {
      const currentIndex = this.relatedArticles.findIndex(a => a.id === this.articleId)
      return currentIndex > 0 ? this.relatedArticles[currentIndex - 1] : null
    },
    nextArticle() {
      const currentIndex = this.relatedArticles.findIndex(a => a.id === this.articleId)
      return currentIndex < this.relatedArticles.length - 1 ? this.relatedArticles[currentIndex + 1] : null
    }
  },
  methods: {
    async loadArticle() {
      this.articleId = parseInt(this.$route.params.id) || 1
      try {
        // 请求文章详情
        const res = await getNewsDetail(this.articleId)
        const detail = res.data || res
        this.article = detail
        // 同时请求新闻列表用于上下篇导航
        const listRes = await getNewsList({ page: 1, pageSize: 50 })
        this.relatedArticles = listRes.data || listRes || []
      } catch (error) {
        console.warn('新闻详情接口请求失败，使用默认数据:', error.message)
      }
    },
    goBack() {
      this.$router.push('/news')
    },
    goToArticle(id) {
      this.$router.push(`/news/${id}`)
    },
    getShareUrl() {
      return window.location.href
    },
    getShareTitle() {
      return this.article ? this.article.title : '新闻动态'
    },
    shareToWeixin() {
      alert('请点击右上角分享按钮分享到微信')
    },
    shareToWeibo() {
      const url = encodeURIComponent(this.getShareUrl())
      const title = encodeURIComponent(this.getShareTitle())
      window.open(`http://service.weibo.com/share/share.php?url=${url}&title=${title}`, '_blank')
    },
    shareToQQ() {
      const url = encodeURIComponent(this.getShareUrl())
      const title = encodeURIComponent(this.getShareTitle())
      window.open(`http://connect.qq.com/widget/shareqq/index.html?url=${url}&title=${title}`, '_blank')
    },
    shareToQzone() {
      const url = encodeURIComponent(this.getShareUrl())
      const title = encodeURIComponent(this.getShareTitle())
      window.open(`https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=${url}&title=${title}`, '_blank')
    },
    shareToDouban() {
      const url = encodeURIComponent(this.getShareUrl())
      const title = encodeURIComponent(this.getShareTitle())
      window.open(`https://www.douban.com/share/service?href=${url}&name=${title}`, '_blank')
    },
    shareToTieba() {
      const url = encodeURIComponent(this.getShareUrl())
      const title = encodeURIComponent(this.getShareTitle())
      window.open(`http://tieba.baidu.com/f/commit/share/openShareApi?url=${url}&title=${title}`, '_blank')
    }
  },
  created() {
    this.loadArticle()
  },
  watch: {
    '$route.params.id'() {
      this.loadArticle()
    }
  }
}
</script>

<style lang="scss" scoped>
.news-detail-page {
  padding-top: 60px;
  
  .page-header {
    background: linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url('../assets/images/news-banner.png');
    background-size: cover;
    background-position: center;
    height: 340px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    text-align: center;
    
    .container {
      max-width: 1200px;
      margin: 0 auto;
      padding: 0 20px;
      
      h1 {
        font-size: 42px;
        margin-bottom: 15px;
        font-weight: 700;
      }
      
      p {
        font-size: 18px;
        opacity: 0.9;
      }
    }
  }
  
  .detail-container {
    max-width: 1100px;
    margin: 50px auto;
    padding: 0 20px;
    
    .article-wrapper {
      background: #fff;
      border-radius: 12px;
      padding: 60px 80px;
      box-shadow: 0 4px 20px rgba(0,0,0,0.08);
      
      @media screen and (max-width: 768px) {
        padding: 25px 20px;
      }
      
      .article-header {
        text-align: center;
        margin-bottom: 40px;
        padding-bottom: 30px;
        border-bottom: 2px solid #eee;
        
        .article-title {
          font-size: 30px;
          font-weight: 700;
          color: #1a1a2e;
          line-height: 1.6;
          margin-bottom: 20px;
          
          @media screen and (max-width: 768px) {
            font-size: 22px;
          }
        }
        
        .article-meta {
          display: flex;
          justify-content: center;
          flex-wrap: wrap;
          gap: 20px;
          
          .meta-item {
            display: flex;
            align-items: center;
            color: #999;
            font-size: 14px;
            
            i {
              margin-right: 5px;
            }
          }
        }
      }
      
      .article-content {
        line-height: 2.2;
        font-size: 17px;
        color: #333;
        word-break: break-word;
        
        ::v-deep {
          p {
            margin-bottom: 24px;
            text-align: justify;
            text-indent: 2em;
          }
          
          h2 {
            font-size: 24px;
            font-weight: 600;
            color: #1a1a2e;
            margin: 40px 0 20px;
            padding-left: 15px;
            border-left: 4px solid #409eff;
          }
          
          h3 {
            font-size: 20px;
            font-weight: 600;
            color: #2c3e50;
            margin: 30px 0 15px;
          }
          
          img {
            max-width: 100%;
            height: auto;
            margin: 24px 0;
            border-radius: 8px;
            display: block;
          }
          
          blockquote {
            margin: 20px 0;
            padding: 15px 25px;
            background: #f5f7fa;
            border-left: 4px solid #409eff;
            color: #666;
          }
          
          ul, ol {
            padding-left: 2em;
            margin-bottom: 20px;
            
            li {
              margin-bottom: 8px;
            }
          }
          
          a {
            color: #409eff;
            text-decoration: none;
            
            &:hover {
              text-decoration: underline;
            }
          }
        }
      }
      
      .article-footer {
        margin-top: 50px;
        padding-top: 30px;
        border-top: 1px solid #eee;
        text-align: center;
      }
      
      .article-nav {
        margin-top: 30px;
        padding-top: 30px;
        border-top: 1px solid #eee;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        gap: 15px;
        
        .nav-prev,
        .nav-next {
          flex: 1;
          min-width: 200px;
          
          @media screen and (max-width: 576px) {
            width: 100%;
          }
        }
        
        .nav-next {
          text-align: right;
        }
        
        .nav-label {
          color: #999;
          font-size: 14px;
        }
        
        .nav-link {
          color: #409eff;
          text-decoration: none;
          font-size: 14px;
          transition: color 0.3s;
          
          &:hover {
            color: #66b1ff;
          }
        }
      }
      
        .article-share {
          margin-top: 30px;
          padding-top: 30px;
          border-top: 1px dashed #e0e0e0;
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 12px;
          
          .share-label {
            color: #999;
            font-size: 14px;
          }
          
          .share-icons {
            display: flex;
            gap: 20px;
            align-items: center;
          }
          
          .share-btn {
            background: transparent;
            border: none;
            cursor: pointer;
            padding: 4px;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: transform 0.2s, opacity 0.2s;
            
            &:hover {
              transform: scale(1.2);
              opacity: 0.8;
            }
          }
        }
    }
  }
}

@media screen and (max-width: 768px) {
  .news-detail-page {
    .page-header {
      height: 300px;
      
      .container {
        h1 {
          font-size: 28px;
        }
        
        p {
          font-size: 16px;
        }
      }
    }
    
    .detail-container {
      margin: 30px auto;
    }
  }
}
</style>